import React from 'react'
import PropTypes from 'prop-types'
import ModalMyAvant from './ModalMyAvant'
import ModalMessage from './ModalMessage'
import './ContentfulModal.scss'

function ContentfulModal({ apiResponse, handleModal, modalData }) {
  const { successfulResponse, failedResponse, backgroundImage } = modalData

  const data = {
    modalInformation: apiResponse,
    handleModal,
    successfulResponse,
    failedResponse
  }

  const classNames = {
    container: 'modal__overlay modal__overlay--inverse modal__overlay--show',
    content: 'modal__fpo modal__content',
    message: 'modal__content-message-box'
  }

  return (
    <ModalMyAvant
      classNames={classNames}
      handleModal={handleModal}
      backgroundImage={backgroundImage}
    >
      <ModalMessage data={data} />
    </ModalMyAvant>
  )
}

ContentfulModal.defaultProps = {
  apiResponse: {},
  handleModal: () => {}
}

ContentfulModal.propTypes = {
  apiResponse: PropTypes.object,
  handleModal: PropTypes.func,
  modalData: PropTypes.object.isRequired
}
export { query as modalData } from './modalQuery'

export default ContentfulModal
